









































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

import Attachments from "@/components/Controls/Attachments.vue";
import ProductTypeChildrenTab from "../ProductTypeForm/ProductTypeChildrenTab.vue";
import {
  exportProductSpecDocx,
  exportProductSpecPdf,
  createProductSpecExportOptions
} from "../utils/productSpecExport";
import { STORE_KEY, store } from "../ProductTypeForm/_store";
import { resolveCatalogEntityId } from "../utils/openCatalogEntity";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "document",
      "form",
      "meta",
      "childrenLoaded",
      "parentTypeColor",
      "parentTypeName",
      "priceSegmentColor",
      "priceSegmentName",
      "technologyColor",
      "technologyName",
      "savedBusinessScopes"
    ]),
    ...mapState("ubic", ["token"])
  },
  components: {
    Attachments,
    ProductTypeChildrenTab
  }
})
export default class ProductTypeViewForm extends Vue {
  @Prop({ type: Object }) documentPreview!: any;

  document!: any;
  form!: any;
  meta!: any;
  token!: string;
  childrenLoaded!: boolean;
  parentTypeColor!: string | null;
  parentTypeName!: string | null;
  priceSegmentColor!: string | null;
  priceSegmentName!: string | null;
  technologyColor!: string | null;
  technologyName!: string | null;
  savedBusinessScopes!: any[];

  activeTab = 0;

  get isParentProduct() {
    return this.form && this.form.record_type === "parent_product";
  }

  get parentProductId() {
    const entityId = resolveCatalogEntityId(this, this.documentPreview);
    if (entityId != null) {
      return entityId;
    }
    if (this.document && this.document.id) {
      return this.document.id;
    }
    return null;
  }

  get typeName() {
    if (this.parentTypeName) {
      return this.parentTypeName;
    }
    if (this.documentPreview && this.documentPreview.parent_type_name) {
      return this.documentPreview.parent_type_name;
    }
    if (
      this.form &&
      this.form.parent_id &&
      this.meta &&
      this.meta.products_types
    ) {
      const type = this.meta.products_types.find(
        (item: any) => item.id === this.form.parent_id
      );
      return type ? type.name : "-";
    }
    return "-";
  }

  get technologyNameLabel() {
    if (this.technologyName) {
      return this.technologyName;
    }
    if (this.documentPreview && this.documentPreview.technology_name) {
      return this.documentPreview.technology_name;
    }
    if (
      this.form &&
      this.form.technology_id &&
      this.meta &&
      this.meta.product_technologies
    ) {
      const technology = this.meta.product_technologies.find(
        (item: any) => item.id === this.form.technology_id
      );
      return technology ? technology.name : "-";
    }
    return "-";
  }

  get priceSegmentNameLabel() {
    if (this.priceSegmentName) {
      return this.priceSegmentName;
    }
    if (this.documentPreview && this.documentPreview.price_segment_name) {
      return this.documentPreview.price_segment_name;
    }
    if (
      this.form &&
      this.form.price_segment_id &&
      this.meta &&
      this.meta.product_price_segments
    ) {
      const segment = this.meta.product_price_segments.find(
        (item: any) => item.id === this.form.price_segment_id
      );
      return segment ? segment.name : "-";
    }
    return "-";
  }

  get priceSegmentHighlightStyle() {
    if (!this.priceSegmentColor) {
      return {};
    }
    return { backgroundColor: this.priceSegmentColor };
  }

  get technologyHighlightStyle() {
    if (!this.technologyColor) {
      return {};
    }
    return { backgroundColor: this.technologyColor };
  }

  get businessScopesLabel() {
    if (!this.savedBusinessScopes || !this.savedBusinessScopes.length) {
      return "-";
    }

    return this.savedBusinessScopes
      .map((scope: any) => scope.name)
      .filter(Boolean)
      .join(", ");
  }

  get parentTypeHighlightStyle() {
    if (!this.parentTypeColor) {
      return {};
    }
    return { backgroundColor: this.parentTypeColor };
  }

  get tradeMarkName() {
    if (this.documentPreview && this.documentPreview.trade_mark_name) {
      return this.documentPreview.trade_mark_name;
    }
    if (
      this.form &&
      this.form.trade_mark_id &&
      this.meta &&
      this.meta.product_trade_marks
    ) {
      const tradeMark = this.meta.product_trade_marks.find(
        (item: any) => item.id === this.form.trade_mark_id
      );
      return tradeMark ? tradeMark.name : "-";
    }
    return "-";
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    const entityId = resolveCatalogEntityId(this, this.documentPreview);
    if (entityId != null) {
      this.$store.dispatch(`${STORE_KEY}/init`, { id: entityId });
    }
  }

  onTabChange(tabIndex: number) {
    if (tabIndex === 1 && this.parentProductId && !this.childrenLoaded) {
      this.$store.dispatch(`${STORE_KEY}/loadChildren`, this.parentProductId);
    }
  }

  async exportSpecification(format: "docx" | "pdf") {
    const productData = {
      ...this.form,
      product_name: this.form.name,
      type_name: this.typeName !== "-" ? this.typeName : "",
      technology_name:
        this.technologyNameLabel !== "-" ? this.technologyNameLabel : "",
      price_segment_name:
        this.priceSegmentNameLabel !== "-" ? this.priceSegmentNameLabel : "",
      trade_mark_name: this.tradeMarkName !== "-" ? this.tradeMarkName : ""
    };

    const exportOptions = createProductSpecExportOptions(
      this as any,
      productData,
      this.form.name
    );

    try {
      if (format === "docx") {
        await exportProductSpecDocx(exportOptions);
      } else {
        await exportProductSpecPdf(exportOptions);
      }

      this.$buefy.snackbar.open({
        type: "is-success",
        message: "Спецификация успешно скачана"
      });
    } catch (error) {
      console.error("[ProductTypeViewForm.specExport] error", error);
      this.$buefy.snackbar.open({
        type: "is-danger",
        message: "Ошибка при генерации файла спецификации"
      });
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
  }
}
